module.exports = __webpack_public_path__ + "ui-static/img/not-found-items_dark.7e4e3d46.svg";